import { Controller } from "stimulus"
import flatpickr from "flatpickr"
import { Portuguese } from "flatpickr/dist/l10n/pt.js"

// Alterna blocos Pagar.me (PF vs PJ) e desabilita inputs da seção oculta para não irem no submit.
// O `change` é delegado no elemento do controller (não no select) para evitar conflito com Choices.js
// e com múltiplas ações no mesmo controle.
// Seções são encontradas por `data-recipient-section` (evita Stimulus targets que falham com Turbo
// ou com mais de uma instância / escopo ambíguo).
// Datas: mesma classe/markup que apresentações (`datetime-select` + `datetime-select-input`), só data (sem hora),
// formato d/m/Y enviado ao servidor (exigência Pagar.me).
export default class extends Controller {
  connect() {
    this.initDatetimePickers()
    this.applyVisibility()
  }

  disconnect() {
    if (this.flatpickrInstances) {
      this.flatpickrInstances.forEach((fp) => fp.destroy())
      this.flatpickrInstances = []
    }
  }

  initDatetimePickers() {
    this.flatpickrInstances = []
    const config = {
      enableTime: false,
      dateFormat: "d/m/Y",
      locale: Portuguese,
      allowInput: true
    }

    this.element.querySelectorAll(".datetime-select-input").forEach((input) => {
      this.flatpickrInstances.push(flatpickr(input, config))
    })
  }

  toggle(event) {
    if (event) {
      const t = event.target
      if (!t || t.name !== "bank_account[recipient_person_type]") return
    }
    this.applyVisibility()
  }

  applyVisibility() {
    const sel = this.element.querySelector('select[name="bank_account[recipient_person_type]"]')
    if (!sel) return
    const v = sel.value
    const ind = this.element.querySelector('[data-recipient-section="individual"]')
    const corp = this.element.querySelector('[data-recipient-section="corporation"]')
    if (ind) this.setSectionState(ind, v === "individual")
    if (corp) this.setSectionState(corp, v === "corporation")
  }

  setSectionState(sectionEl, visible) {
    sectionEl.classList.toggle("is-display-none", !visible)
    sectionEl.querySelectorAll("input, select, textarea").forEach((el) => {
      el.disabled = !visible
    })
  }
}
